import {Grid, TextField} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {inputChangeEvent, mapSetState, SetState} from "../../util/FormHandlers";
import {useEffect, useMemo, useState} from "react";
import {useDebouncedCallback} from "use-debounce";


export function TextSearchFilter<FilterForm extends {} & { [P in PropertyName]: string }, PropertyName extends keyof FilterForm>(
    {
        filter,
        setFilter,
        property,
    }: {
        filter: FilterForm,
        setFilter: SetState<FilterForm>,
        property: PropertyName,
    }
) {
    const value: string = filter[property];
    const setValue = useMemo(
        () => mapSetState(setFilter, property),
        [setFilter, property],
    );
    const debouncedSetValue = useDebouncedCallback(
        newValue => setValue(newValue),
        300,
    );

    const [localValue, setLocalValue] = useState(value);

    useEffect(
        () => setLocalValue(currentValue => currentValue.trim() === value ? currentValue : value),
        [value],
    );

    const handleChange = useMemo(
        () => inputChangeEvent(newValue => {
            setLocalValue(newValue);
            debouncedSetValue(newValue);
        }),
        [setLocalValue, debouncedSetValue]
    );

    return (
        <Grid size={{md: 'grow', xs: 12}} sx={{minWidth: 200}}>
            <TextField
                fullWidth
                label="Search"
                variant="outlined"
                value={localValue}
                onChange={handleChange}
                slotProps={{
                    input: {startAdornment: <SearchIcon sx={{color: "action.active", mr: 1}}/>}
                }}
            />
        </Grid>
    );
}
